<template lang="pug">
  include Test.pug
</template>

<script type="text/javascript">
import _ from "underscore";
import dayjs from "dayjs";
import api from "@/service/api";
import timer from "@/service/timer";
import { mapState } from "vuex";
import TestChoice from "@/components/TestChoice";
import ProgressionBar from "@/components/ProgressionBar";
import QuestionErrorBlock from "@/components/QuestionErrorBlock";
import utils from "@/service/utils";
import { QUESTION_TIME } from "@/service/constants";

export default {
  name: "Test",
  props: ["uuid", "subfamilyParam"],
  components: {
    TestChoice,
    ProgressionBar,
    QuestionErrorBlock,
  },
  computed: _.extend(mapState(["token", "username"]), {
    totalQuestions: function () {
      return this.questions.length;
    },
    currentQuestionInteger: function () {
      return this.index + 1;
    },
    currentPercent: function () {
      if (this.solution.completed) return 100;
      let temp =
        Math.max(0, this.currentQuestionInteger - 1) / this.totalQuestions;
      return parseInt(temp * 100, 10);
    },
    solutionPercentage: function () {
      let temp = Math.max(0, this.solution.asserted) / this.totalQuestions;
      return parseInt(temp * 100, 10);
    },
  }),
  data() {
    return {
      title: null,
      backgroundImage: "",
      suffixOptions: ["A", "B", "C", "D", "E", "F", "G"],
      limitTime: null,
      enabledTime: true,
      remainingSeconds: null,
      report: false,
      mode: null,
      family: null,
      subfamily: null,
      questions: [], // with keys: choices, information, pk, question
      index: 0,
      lastIndex: 0,
      showingAnswer: false,
      answer: null,
      question: null,
      selectedChoice: null,
      reportText: "",
      points: null,
      solutions: [],
      errors: [],
      solution: {
        asserted: 0,
        completed: false,
        timeout: 0,
        failed: 0,
        nota: null,
      },
    };
  },
  created() {
    const self = this;
    api
      .subfamily(this.subfamilyParam)
      .then((response) => {
        const data = response.data;
        const family = data.family;
        self.title = data.name;
        if (family.image) {
          self.backgroundImage = family.image;
        }
      })
      .catch();
    api
      .getTest(this.token, this.uuid)
      .then((response) => {
        const data = response.data;
        self.family = data.family;
        self.subfamily = data.subfamily;
        self.questions = data.questions;
        self.lastIndex = self.questions.length - 1;
        self.question = _.first(self.questions);
      })
      .catch((err) => {});

    // every second check
    setInterval(function () {
      if (self.enabledTime) {
        if (!self.limitTime || self.showingAnswer) {
          self.remainingSeconds = null;
        } else {
          const currentNow = dayjs();
          self.remainingSeconds =
            QUESTION_TIME -
            parseInt(currentNow.diff(self.limitTime, "seconds"), 10);
          if (self.remainingSeconds < 1) {
            let maxIndex = self.questions.length - 1;
            let closeTest = self.index == maxIndex;
            self.solution.timeout += 1;

            if (self.question) {
              self.toggleChoice(
                _.first(_.without(self.question.choices, self.question.answer))
              );
              self.nextQuestion(closeTest);
            }
          }
        }
      }
    }, 1000);
  },
  methods: {
    toggleReport() {
      this.report = !this.report;
    },
    toggleChoice(choice) {
      if (this.selectedChoice == choice) {
        this.selectedChoice = null;
      } else {
        this.selectedChoice = choice;
      }
    },
    sendReport() {
      const self = this;
      api
        .report(this.question.question_pk, this.reportText, this.token)
        .then((response) => {
          self.reportText = "";
          self.report = false
        })
        .catch();
    },
    selectMode(newMode) {
      this.mode = newMode;
      this.limitTime = dayjs();
      this.remainingSeconds = null;

      // starting the test
      timer.init(this.uuid);
    },
    showAnswer() {
      this.showingAnswer = true;
      this.answer = this.question.answer;
    },
    jumpQuestion() {
      const self = this
      this.limitTime = null;
      this.remainingSeconds = null;
      this.showingAnswer = false
      this.answer = false
      this.errors.push(JSON.parse(JSON.stringify(_.extend(this.question, {
        selectedAnswer: null,
      }))));

      let nextIndex = this.index + 1;
      if (nextIndex > this.lastIndex) return;

      this.solutions.push({
        pk: _.clone(this.question.pk),
        choice: "",
      });

      // Null step
      this.selectedChoice = null;
      this.index = nextIndex;
      this.question = null;

      this.$nextTick(function () {
        self.question = self.questions[nextIndex];
        self.limitTime = dayjs();
      });
    },
    doClose() {
      this.$router.push({
        "name": "Tree",
      })
    },
    nextQuestion(closeTest = false) {
      if (this.mode == "runtime" && !this.showingAnswer) {
        this.limitTime = null;
        this.remainingSeconds = null;
        this.showAnswer();
        return;
      }

      if (this.showingAnswer) {
        this.showingAnswer = false;
        this.answer = false;
      }

      // If the question was wrong to the pile
      if (this.question.answer != this.selectedChoice) {
        const questionPk = this.question.pk
        const totalSamePk = _.where(this.errors, {pk: questionPk}).length
        if (!totalSamePk) {
          this.errors.push(JSON.parse(JSON.stringify(_.extend(this.question, {
            selectedAnswer: _.clone(this.selectedChoice),
          }))));
        }
      }

      const self = this;

      if (!closeTest) {
        if (!this.selectedChoice) return;
        let nextIndex = this.index + 1;
        if (nextIndex > this.lastIndex) return;

        this.solutions.push({
          pk: _.clone(this.question.pk),
          choice: _.clone(`${this.selectedChoice}`),
        });

        // Null step
        this.selectedChoice = null;
        this.index = nextIndex;
        this.question = null;

        this.$nextTick(function () {
          self.question = self.questions[nextIndex];
          self.limitTime = dayjs();
        });
      } else {
        this.solutions.push({
          pk: _.clone(this.question.pk),
          choice: _.clone(`${this.selectedChoice}`),
        });

        // all null and closing test
        this.selectedChoice = null;
        this.question = null;

        api
          .solveTest(this.token, this.uuid, JSON.stringify(this.solutions))
          .then((response) => {
            const data = response.data;
            self.solution.asserted = data.asserted;
            self.solution.completed = data.completed;
            self.solution.failed = data.failed;
            self.solution.nota = data.nota

            // register the end and store stats
            const stats_minutes = timer.end(self.uuid);
            const token = self.$store.state.token;
            const subfamily = self.subfamilyParam;
            const stats_questions = self.questions.length;
            const stats_questions_ok = data.asserted;
            const stats_questions_wrong = data.failed;
            const stats_questions_empty = self.solution.timeout;
            api
              .storeStats(
                token,
                subfamily,
                stats_questions,
                stats_questions_ok,
                stats_questions_wrong,
                stats_questions_empty,
                stats_minutes
              )
              .then(response => {
                const data2 = response.data
                const points = data2.stats.points
                self.points = points
              })
              .catch();
          })
          .catch((err) => {});
      }
    },
  },
  watch: {},
  filters: {
    fixdecimal: function (value) {
      return utils.fixdecimal(value);
    },
  },
};
</script>
